<template>
  <div class="products-block">
    <selected-tyres-products
      v-if="showSelectedProducts"
      :selected-products="selectedProducts"
      :show-purchase-price="showPurchasePrice"
      :is-editable="productsAreEditable"
      :block-type="blockType"
      @toggle-edit-modal="toggleEditModal"
      @remove-from-selected="removeFromSelected"
      @mark-product-as-tyres="markProductAsTyres"
    />

    <app-button
      v-if="showButtons"
      :disabled="!productsAreEditable"
      :data-qa="`${blockType}-more-products-button`"
      @click="toggleListModal(true)"
      >{{ i18n.t(`/ProductBlocks/SeeMoreButton`) }}</app-button
    >

    <app-button
      v-if="canAddProducts && showButtons"
      :disabled="!productsAreEditable"
      :data-qa="`add-${blockType}-product-button`"
      @click="toggleEditModal(true)"
      >{{ i18n.t(`/ProductBlocks/tyresaccessories/AddButton`) }}</app-button
    >
    <modal
      v-if="showListModal"
      :title="i18n.t(`/ProductBlocks/${blockType}/Title`)"
      track-category="service flow"
      @close="toggleListModal(false)"
    >
      <loader v-if="loading" />

      <template v-else>
        <slot />
        <dealer-accessories-block
          v-if="blockType === 'DealerAccessories'"
          :products="products"
          :selected-products="selectedProducts"
          :show-purchase-price="showPurchasePrice"
          :categories="allCategories"
          @add-to-selected="addToSelected"
          @remove-from-selected="removeFromSelected"
        >
        </dealer-accessories-block>
      </template>
    </modal>
    <modal
      v-if="showEditModal"
      :title="editProductTitle"
      track-category="service flow"
      @close="toggleEditModal(false)"
    >
      <edit-product
        :show-purchase-price="showPurchasePrice"
        :product="editProduct"
        :categories="productsCategories"
        :is-tyres-products="isTyresProducts"
        @close-edit-modal="closeEditModal"
      />
    </modal>
  </div>
</template>

<script>
import DealerAccessoriesBlock from '@/components/generic/presentational/organisms/productsBlock/DealerAccessoriesBlock.vue'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import Modal from '@/components/generic/presentational/molecules/modal/Modal.vue'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import SelectedTyresProducts from '@/components/generic/presentational/molecules/selectedTyresProducts/SelectedTyresProducts.vue'
import EditProduct from '@/components/generic/presentational/molecules/editProduct/EditProduct.vue'
import constants from '@/utils/constants'

export default {
  components: {
    Loader,
    AppButton,
    Modal,
    SelectedTyresProducts,
    EditProduct,
    DealerAccessoriesBlock,
  },
  provide() {
    return {
      filterProductsByCategory: this.filterProductsByCategory,
    }
  },
  props: {
    products: {
      type: Array,
      default: () => [],
    },
    selectedProducts: {
      type: Array,
      default: () => [],
    },
    canAddProducts: {
      type: Boolean,
      default: true,
    },
    showPurchasePrice: {
      type: Boolean,
      default: false,
    },
    productsAreEditable: {
      type: Boolean,
      default: true,
    },
    blockType: {
      type: String,
      required: true,
    },
    productsCategories: {
      type: Array,
      default: () => [],
    },
    expandable: {
      type: Boolean,
      default: false,
    },
    showSelectedProducts: {
      type: Boolean,
      default: true,
    },
    showButtons: {
      type: Boolean,
      default: true,
    },
    isTyresProducts: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['add-to-selected', 'remove-from-selected', 'mark-product-as-tyres'],
  data() {
    return {
      editProduct: null,
      showListModal: false,
      showEditModal: false,
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      allCategories: constants.PRODUCT_CATEGORIES,
    }
  },
  computed: {
    editProductTitle() {
      if (this.editProduct) {
        return 'Optie wijzigen'
      }
      return 'Optie aanmaken'
    },
    loading() {
      return this.products.length === 0
    },
  },
  methods: {
    toggleListModal(open) {
      this.showListModal = open
    },
    toggleEditModal(open, product) {
      this.editProduct = product
      this.showEditModal = open
    },
    addToSelected(selectedProduct) {
      this.$emit('add-to-selected', selectedProduct)
    },
    removeFromSelected(deselectedProduct) {
      this.$emit('remove-from-selected', deselectedProduct)
    },
    closeEditModal(product) {
      this.toggleEditModal(false)
    },
    filterProductsByCategory(key) {
      return this.products.filter((p) => p.Category === key)
    },
    markProductAsTyres(selectedProduct) {
      this.$emit('mark-product-as-tyres', selectedProduct)
    },
  },
}
</script>

<style lang="scss" scoped>
.products-block {
  margin-bottom: 2em;
}

.category {
  position: relative;
}

.title {
  position: sticky;
  top: -0.6em;
  z-index: 9;
  background: #fff;
  margin-bottom: 0.5em;
  border-bottom: 1px solid $gray-light;
  padding: 0.25em 0 0.5em;
  box-shadow: $shadow-focus-ring;
}
</style>
